export const ProformaLabel = {
  ProformaInvoiceTitle: "Proforma Invoice",
  VendorName: "Customer Name",
  VendorID: "Customer ID",
  ProductName: "Product Name",
  ProformaInvoice: "Proforma Invoice",
  NewProformaInvoice: "New Proforma Invoice",
  EditProformaInvoice: "Edit Proforma Invoice",
  ProformaInvoiceDT: "Proforma Invoice Date",
  TaxableValue: "Taxable Value",
  GST: "GST",
  TaxAmt: "Tax Invoice Amt (Inc of Tax)",
  Warranty: "Warranty",
  Remarks: "Remarks",
  ShipTo: "Ship To",
  BillTo: "Bill To",
  DeliveryNote: "Delivery Note",
  DeliveryDate: "Delivery Date",
  TermsOfPayment: "Mode/Terms Of Payment",
  ReferenceNoDate: "Reference Date",
  VehicleRegNo: "Vehicle Reg./VDN No.",
  SerialNo: "Chassis/Serial No.",
  EngineNo: "Engine No.",
  BuyerOrderNo: "Buyers Order No.",
  BuyerDate: "Buyers Date",
  DispatchedThrough: "Dispatched Through",
  Destination: "Destination",
  MotorVehicleNo: "Motor Vehicle No.",
  DeliveryTerms: "Terms Of Delivery",
  Discount: "Discount",
  Product: "Product",
  SrNo: "Sr No.",
  DescriptionOfGoods: "Description Of Goods",
  DescriptionSubHead: "Description Sub Head",
  HSN_SAC: "HSN/SAC",
  QuotationGst: "Quotation GST",
  Quantity: "Quantity",
  Rate: "Rate",
  Per: "UOM",
  Amount: "Amount",
  QuoteNo: "Reference No.",
  GstAmount: "GST Amount",
  TotalAmount:"Total Amount",
  WorkOrderNo: "Work Order No",
};
export const ConditionOptions = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
];
export const ProformaKey = {
  VendorName: "customer_name",
  VendorID: "customer_id",
  ProformaInvoice: "pro_in_no",
  ProformaInvoiceDT: "pro_in_dt",
  ProductName: "product.product_code",
  TaxableValue: "taxable",
  GST: "gst",
  TaxInvoiceAmt: "tax_invoice_amount",
  Warranty: "warranty",
  Remarks: "remarks",
  ShipTo: "ship_to",
  BillTo: "bill_to",
  DeliveryNote: "delivery_note",
  DeliveryDate: "delivery_date",
  TermsOfPayment: "terms_of_payment",
  ReferenceNoDate: "reference_no_date",
  VehicleRegNo: "vehicle_reg_no",
  SerialNo: "serial_no",
  EngineNo: "engine_no",
  BuyerOrderNo: "buyer_order_no",
  BuyerDate: "buyer_date",
  DispatchedThrough: "dispatched_through",
  Destination: "destination",
  MotorVehicleNo: "motor_vehicle_no",
  DeliveryTerms: "delivery_terms",
  SrNo: "sr_no",
  DescriptionOfGoods: "description",
  DescriptionSubHead: "sub_description",
  HSN_SAC: "hsn_sac_code",
  QuotationGst: "gst",
  Quantity: "quantity",
  Rate: "rate",
  Per: "uom",
  Amount: "with_gst_amount",
  GstAmount: "gst_amount",
};